export const REWARDS_ICONS = {
  SAVINGS_SELECTED: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Savings_48_1_f598911668.webp',
  SAVINGS_UNSELECTED: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Savings_48_1_f598911668.webp',
  REWARDS_SELECTED: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Frame_1_d7070d6d82.webp',
  REWARDS_UNSELECTED: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Frame_7649fc7aa3.webp',
  BACK_ICON: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/back_icon_7575efa2c5.webp',
} as const

export const REWARDS_ROUTES = {
  SAVINGS_TAB: '/myrewards',
  REWARDS_TAB: '/myrewards/?tab=rewards',
  HOME: '/',
  FALLBACK_NON_APP: '/',
} as const

export const FETCH_REWARDS_ENDPOINT = '/rewards/api/v1/fetch'
export const FETCH_ASSET_REWARDS_ENDPOINT = '/rewards/api/v1/custom/fetch-assets-coupons'
export const UPSERT_USER_ENRICHED_PROFILE_ATTRIBUTES_ENDPOINT =
  '/rewards/internal/api/v1/user-enriched-profile-attributes/upsert'
export const FETCH_USER_ID = '/api/user/get/'
export const OAUTH_GENERATE_TOKEN_ENDPOINT = '/token'
export const BEARER_TOKEN_KEY = 'bearerToken'
export const SUCCESS_MESSAGE = 'We’ve sent the app download link to your mobile number'
export const ERROR_MESSAGE = 'Error! Please try again Later'
export const APP_LINK_GENERIC = 'https://ackoapp.onelink.me/TnnH/geb0pi1v'
export const COUPON_FALL_BACK_VALUE = {
  appLink:
    'https://www.acko.com/gi/lp/new-car-comprehensive-hi?utm_source=coupons_atl&utm_medium=coupons_atl&utm_campaign=coupons_atl',
  productImage: 'https://acko-cms.ackoassets.com/Car_Sedan_Light_5ca5ffe0ae.png',
  productName: 'product name',
}
export const REWARDS_LOGIN = (phoneNumber = '') =>
  `/authn/v1/signin?state=%2Fmyrewards${phoneNumber && `&mobile=${phoneNumber}`}`

export const SHARING_URLS = {
  ACKO_APP_DOWNLOAD: 'https://ackoapp.onelink.me/TnnH/5gb7vlt7',
  SHARING_ICON: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Frame_1244831563_60e369d748.webp',
} as const

export const SAVINGS_ICONS = {
  CHEVRON_RIGHT: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Chevron_right_d36b4b1337.webp',
  CAR_ARROW: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/svgviewer_output_2_d82551a1c5.webp',
} as const
export const ASSET_REWARD_FETCH_TIMEOUT = 2000
export const TOKEN_EXPIRY_DEFAULT_TIME = 240000
